module.exports = __webpack_public_path__ + "img/IMG_8985.8ead4b5a.jpg";